<template>
  <div class="flex lg:w-full h-screen justify-center">
    <div class="img-login hidden lg:block lg:w-6/12 bg-white relative">
      <div class="h-full w-full bg-black absolute opacity-30" />
      <div
        class="absolute blur-div flex flex-col p-8 h-full w-full text-white justify-between"
      >
        <CImg
          class="inline-block w-36 lg:w-40 mb-2"
          src="img/simhp/logo-white-login.svg"
        />
        <div class="text-left">
          <!-- <h1 class="tracking-wide text-5xl">
            SimhpNas
          </h1> -->
          <div class="mb-3">
            <CImg
              class="inline-block w-6 lg:w-5"
              src="img/simhp/v_avocado.svg"
            />
            <span class="font-medium ml-2 tracking-wide">Versi 1.0</span>
          </div>
          <p class="text-base lg:text-xl">
            Sistem Infomasi Manajemen Hasil Pengawasan Nasional
          </p>
          <div class="mt-2">
            <span class="text-sm"
              >Crafted with ❤️ by Pusinfowas - Badan Pengawasan Keuangan dan
              Pembangunan
              <!-- <a
                href="https://bpkp.go.id"
                target="_blank"
                rel="noopener noreferrer"
                class="font-bold underline"
                >Pusinfowas - Badan Pengawasan Keuangan dan Pembangunan</a
              > -->
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col w-full lg:w-6/12 bg-white p-6">
      <div class="h-32 w-full" />
      <div class="w-full h-full m-auto lg:max-w-sm">
        <div
          class="flex h-5/6 flex-col justify-center text-left w-full pt-10 relative"
        >
          <div
            class="flex absolute top-0 justify-start content-center mb-4 lg:hidden"
          >
            <!-- <CImg class="inline-block w-8 mr-2" src="/img/simhp/logo.svg" /> -->
            <CImg
              class="inline-block h-7 mr-2"
              src="img/simhp/logo-color-login.svg"
            />
            <!-- <h3 class="text-2xl font-bold inline-block">SIMHPNAS</h3> -->
          </div>
          <div>
            <h2 class="text-2xl font-semibold mb-2">Login</h2>
            <p class="tracking-wide mb-3">Silahkan masuk untuk melanjutkan.</p>
            <form
              method="POST"
              class="flex flex-col w-full gap-3"
              @submit.prevent="submitForm"
            >
              <!-- <div class="flex flex-wrap mb-4">
            </div> -->
              <input
                v-model="email"
                class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                type="text"
                placeholder="email"
              />
              <input
                v-model="password"
                class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-5"
                type="password"
                placeholder="password"
              />
              <!-- class="rounded-lg appearance-none block w-full bg-red-500 text-white py-3 px-4 leading-tight hover:bg-red-600" -->
              <button
                class="h-10 w-full rounded-md px-3 py-2 text-sm bg-black hover:opacity-80 text-white focus:border-opacity-0"
                type="submit"
                :disabled="loading"
              >
                <template v-if="loading">
                  <CSpinner color="white" size="sm" class="mr-2" />
                  <!-- Loading... -->
                </template>
                <template v-else> Login </template>
              </button>
              <p class="tracking-normal">
                Jika belum punya akun, silahkan
                <!-- <a
                href="mailto:simhpnas@bpkp.go.id?subject=Permintaan Piloting SIMHPNAS"
                target="_blank"
                class="inline-block hover:underline text-red-500 hover:text-red-600"
              > -->
                hubungi admin unit
                <!-- </a> -->
              </p>
              <CAlert
                v-if="showMessage"
                class=""
                color="danger"
                :show.sync="currentAlertCounter"
                close-button
              >
                {{ message }}
                <CProgress
                  :max="5"
                  :value="currentAlertCounter"
                  height="3px"
                  color="danger"
                  animate
                />
              </CAlert>
            </form>
          </div>
        </div>
        <!-- <div class="text-left h-1/6 flex flex-col justify-end">
          <div class="pb-10">
            <CImg
              class="inline-block w-6 lg:w-5"
              src="img/simhp/v_avocado.svg"
            />
            <span class="text-sm font-medium ml-2 tracking-wide"
              >Versi Alpukat</span
            >
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
// import CoverImg from '../../assets/img/cover.jpg';

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      showMessage: false,
      message: '',
      currentAlertCounter: 0,
      mode: 'login',
      error: null,
      loading: false,
    };
  },
  // mounted() {
  //   alert("Web SimaRen PKPT Terbaru di http://simarenpkpt.bpkp.go.id/ dan Web SimaRen PKAU Terbaru di http://simarenpkau.bpkp.go.id/ Terimakasih, Mohon maaf atas ketidaknyamanannya")
  // },
  methods: {
    goRegister() {
      this.$router.push({ path: 'register' });
    },
    async submitForm() {
      let self = this;
      self.loading = true;

      self.showMessage = false;
      self.currentAlertCounter = 5;

      const actionPayload = {
        email: self.email,
        password: self.password,
      };

      try {
        await this.$store.dispatch('auth/login', actionPayload);
        self.email = '';
        self.password = '';
        self.loading = false;
        this.$router.push({ path: 'dashboard' });
      } catch (err) {
        self.loading = false;
        self.message = 'E-mail atau password anda salah!';
        self.showMessage = true;
        self.error = err.message || 'Failed to authenticate, try later.';
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.login-container {
  justify-content: center;
}

.login-container .card-body {
  min-width: 500px;
}

.login-logo {
  background-color: #303c50;
  width: inherit;
}

.b-grey {
  background-color: #303c50;
}

.c-grey {
  color: #eaf6ff;
}

.login-subtitle {
  width: 400px;
  margin-bottom: 1rem;
}

.img-login {
  background-image: url('/img/simhp/bg-login-4.jpg');
  /* background-image: url('https://images.pexels.com/photos/3184287/pexels-photo-3184287.jpeg'); */
  /* Full height */
  height: 100%;

  /* Center and scale the image nicely */
  /* background-position: left; */
  /* margin-right: 100px; */
  /* background-position: right; */
  /* background-position-y: 55%; */
  background-repeat: no-repeat;
  background-size: cover;
}

.blur-div {
  /* backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px); */
}
</style>
